import { useGraphQLApi } from '@/components/Common/useGraphQLApi';
import { useStoreData } from '@/components/Common/useStoreData';
import { CHILD, PARENT } from '../Dashboard/pages/elasticache/elasticache.constants';

export function useGetServiceInstances({ serviceId }) {
  const { getDurationTime } = useStoreData();
  const params = {
    serviceId,
    duration: getDurationTime.value,
  };
  const { data, error, makegraphQLCall, isLoading } = useGraphQLApi({
    params: {},
    queryName: '',
  });

  const fetchServiceInstances = () => {
    makegraphQLCall('getCloudServiceInstances', params, (resp) => {
      const parentInstances = resp?.data?.data?.instanceId.filter(
        (instance) => instance.metaProperty1 === PARENT,
      );
      return resp?.data?.data?.instanceId.map((instance) => {
        if (instance.metaProperty1 === CHILD) {
          const parentEntityId = parentInstances.find(
            (parentInstance) => parentInstance.label === instance.metaProperty2,
          ).key;
          return {
            ...instance,
            parentEntityId,
          };
        }
        return instance;
      });
    });
  };

  return {
    data: data,
    error,
    fetchServiceInstances,
    isLoading,
  };
}
